export const blockIconsMapsBadge = (
	<span className='material-symbols-outlined'>badge</span>
);
